import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from "../../components/Button";
import styles from "./CtaBlock.module.scss";
export const CtaBlock = ({ title, ctaText, text, href }) => {
    return (_jsxs("div", { className: styles.wrapper, children: [_jsx("div", { className: styles.title, children: title }), _jsx("div", { className: styles.text, children: text }), _jsx("div", { className: styles.buttonWrapper, children: _jsx(Button, { href: href, variant: "cta", color: "primary", type: "button", children: ctaText }) })] }));
};
//# sourceMappingURL=CtaBlock.js.map